import React, { useEffect, useState } from "react";
import List from "../../maketingimages/list.png";
import downloadFile from "../../maketingimages/downloadFile.png";
import communication from "../../maketingimages/communication.png";
import Filter from "../../maketingimages/filter.png";
import { getDeviationReport } from "../actioncreator";
import { formatDate, monthStartDate, reverseFormat, todayDate } from "../utils/utils";
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../../reducers/CommonFilters.reducer';
import moment from "moment";
const DeviationReport = () => {
   const dispatch = useDispatch();
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
  const months = [
    "january", "february", "march", "april",
    "may", "june", "july", "august",
    "september", "october", "november", "december"
  ];
  const [objectData, setObjectData] = useState('')
  const [pageNo, setPage] = useState(1)
  const [noOfEntry, setnoOfEntry] = useState(10)

  const [payload, setPayload] = useState({
    fromDate: moment(fromDate).format("DD-MM-YYYY"),
       toDate: moment(toDate).format("DD-MM-YYYY"),
  });

   useEffect(() => {
      setPayload({
        fromDate: moment(fromDate).format("DD-MM-YYYY"),
        toDate: moment(toDate).format("DD-MM-YYYY"),
      })
    }, [fromDate, toDate]);
  const getData = () => {
    getDeviationReport(payload, pageNo, noOfEntry, callback => {
      setObjectData(callback)
    })
  }
  const handleChange = (e) => {
     if(e.target.type === "date" ){
          dispatch({ type: FILTER_ACTION, payload: { [e.target.name]: e.target.value } });
        }
    setPayload({
      ...payload,
      [e.target.name]:
        e.target.type === "date" ? formatDate(e.target.value) : e.target.value,
    });
  };
  const submitFilter = () => {
    getData()
  }
  useEffect(() => {
    getData()
  }, [])
  return (
    <div className="container-fluid marketing-main-css">
      <h3><strong>Deviation Analysis</strong></h3>
      <div className="row" style={{ marginTop: '20px' }}>
        <div className="col-sm-2 col-xs-12">
          <img src={Filter} width={20} height={20} alt="" />
          <span className="ms-3 filterHeaders">Filter</span>
          <select
            name=""
            id=""
            // value={payload.filter}
            className="form-control"
            style={{ width: '100%', padding: '7px' }}
          >
            <option value="daily">Daily</option>
          </select>
        </div>
        <div style={{ position: 'absolute', marginLeft: '16.5%', marginTop: '30px' }}>::</div>
        <div className="col-sm-2 col-xs-12" style={{ marginTop: '4px' }}>
          From
          <input
            type="date"
            id="startDate"
            placeholder="DD/MM/YY"
            name="fromDate"
            value={reverseFormat(payload.fromDate)}
            onChange={handleChange}
            className=" form-control"
            style={{
              border: "1px solid gray",
              borderRadius: "6px",
              padding: "7px",
            }}
          />

        </div>
        <div style={{ position: 'absolute', marginLeft: '33%', marginTop: '30px' }}>-</div>

        <div className="col-sm-2 col-xs-12" style={{ marginTop: '4px' }}>
          <div className="filterHeaders" >to</div>
          <input
            type="date"
            id="endDate"
            name="toDate"
            value={reverseFormat(payload.toDate)}
            onChange={handleChange}
            placeholder="DD/MM/YY"
            className=" form-control"
            style={{
              border: "1px solid gray",
              borderRadius: "6px",
              padding: "10px",
            }}
          />
        </div>
        <div className="col-sm-2 col-xs-12">
          <button
            onClick={() => submitFilter()}
            className="btn reset-btn"
            style={{
              // color: "#006c67",
              // borderColor: "#006c67",
              // backgroundColor: "white",
              marginTop: '27px',
              padding: '8px',
              borderRadius: '5px'

            }}
          >
            Apply Filter
          </button>
        </div>

      </div>
      <hr />
      <div
        className="mt-2"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="d-inline-flex" style={{ display: 'inline-flex' }}>
          <img src={List} alt="" width={18} height={18} style={{ marginTop: '10px' }} />{" "}
          <h4 className="ms-3 leadBreakDown_Header">
            &nbsp;&nbsp;Monthly stats of Budget Planned & Spent on each month
          </h4>
        </div>

      </div>
      <div className='credit-table'>
        <table>
          <thead >
            {/* <thead style={{ background: '#b9d8f9', color: '#000' }}> */}
            <tr className="thead-class">
              <th>Aggregator</th>
              <th>Budget Divided</th>
              {months?.map(month => (
                <th key={month} style={{ textTransform: 'uppercase' }}>{month}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {objectData !== '' ? objectData.map(item => (

              <tr key={item.partnerId}>

                <td>{item.aggregatorName}</td>
                <td style={{ padding: '0px' }} ><div style={{ background: '#ff3d2b', padding: '10px', color: '#fff', fontWeight: '700' }}>Spent</div> <div style={{ background: '#2B78FF', padding: '10px', color: '#fff', fontWeight: '700' }}>Planned </div><div style={{ background: '#4CC78C', padding: '10px', color: '#fff', fontWeight: '700' }}>Left </div>
                </td>
                {months?.map(month => (
                  <td key={month}>
                    {item?.data?.find(d => (d?.month?.trim())?.toLowerCase() === month?.toLowerCase())?.['spentBudget']}
                    <br />
                    <br />
                    {item?.data?.find(d => (d?.month?.trim())?.toLowerCase() === month?.toLowerCase())?.['plannedBudget']}
                    <br />
                    <br />
                    {item?.data?.find(d => (d?.month?.trim())?.toLowerCase() === month?.toLowerCase())?.['leftBudget']}
                  </td>
                ))}
              </tr>
            )) : ""}
          </tbody>
        </table>
      </div>


    </div >

  );
}

export default DeviationReport;
